import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/b5738543dceba8bc9950cf159f9a55b6.jpg"
            alt="مقر الشركة"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-primary/75"></div>
        </div>

        <div className="relative z-10 container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-6xl md:text-7xl font-black text-white mb-6">من نحن</h1>
            <p className="text-2xl text-accent font-bold">شركة روافع المتحدون للمقاولات</p>
          </motion.div>
        </div>
      </section>

      {/* Company Story */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="relative rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=fleet%20of%20yellow%20hydraulic%20cranes%20parked%20in%20organized%20rows%20at%20equipment%20yard%2C%20professional%20crane%20rental%20company%2C%20multiple%20sizes%20of%20construction%20cranes%2C%20Saudi%20Arabia%2C%20aerial%20view%2C%20professional%20industrial%20photography&width=800&height=600&seq=about-story-001&orientation=landscape"
                  alt="أسطول الرافعات"
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-6 right-6 bg-accent text-primary px-6 py-3 rounded-xl font-black text-lg">
                  +15 عاماً من التميز
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 30 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-5xl font-black text-primary mb-6">قصتنا</h2>
              <div className="w-20 h-1 bg-accent mb-8"></div>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                تأسست شركة روافع المتحدون للمقاولات منذ أكثر من 15 عاماً، لتصبح واحدة من الشركات الرائدة في مجال تأجير الرافعات والمعدات الثقيلة في المملكة العربية السعودية. بدأنا بأسطول صغير من الرافعات، واليوم نفخر بامتلاك أكثر من 300 رافعة ومعدة ثقيلة متنوعة.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                على مدار السنوات، ساهمنا في إنجاز أكثر من 500 مشروع ضخم في مختلف أنحاء المملكة، من المشاريع السكنية والتجارية إلى البنية التحتية والمنشآت الحكومية الكبرى. نحن فخورون بكوننا جزءاً من رؤية المملكة 2030 ونساهم في بناء مستقبل المملكة.
              </p>
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 flex items-center justify-center bg-accent/10 rounded-xl">
                  <i className="ri-award-fill text-3xl text-accent"></i>
                </div>
                <div>
                  <p className="text-primary font-bold text-lg">معتمدون من TÜV الألمانية</p>
                  <p className="text-gray-600 text-sm">أعلى معايير الجودة والسلامة</p>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="bg-primary rounded-3xl p-12 text-white"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-accent rounded-2xl mb-8">
                <i className="ri-eye-fill text-5xl text-primary"></i>
              </div>
              <h3 className="text-4xl font-black mb-6">رؤيتنا</h3>
              <p className="text-xl text-gray-300 leading-relaxed">
                أن نكون الشريك الأول والأكثر موثوقية في مجال تأجير الرافعات والمعدات الثقيلة في المملكة العربية السعودية والمنطقة، ونساهم بفعالية في تحقيق رؤية المملكة 2030 من خلال دعم المشاريع التنموية الكبرى.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="bg-white rounded-3xl p-12 shadow-xl"
            >
              <div className="w-20 h-20 flex items-center justify-center bg-primary/10 rounded-2xl mb-8">
                <i className="ri-compass-fill text-5xl text-primary"></i>
              </div>
              <h3 className="text-4xl font-black text-primary mb-6">رسالتنا</h3>
              <p className="text-xl text-gray-700 leading-relaxed">
                تقديم خدمات تأجير رافعات ومعدات ثقيلة عالية الجودة، مع الالتزام الكامل بمعايير السلامة والجودة العالمية، وتوفير حلول مبتكرة ومرنة تلبي احتياجات عملائنا وتساهم في نجاح مشاريعهم.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black text-primary mb-4">قيمنا</h2>
            <div className="w-20 h-1 bg-accent mx-auto"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-shield-check-fill',
                title: 'السلامة',
                description: 'نضع السلامة في المقام الأول ونلتزم بأعلى معايير الأمان في جميع عملياتنا',
              },
              {
                icon: 'ri-star-fill',
                title: 'الجودة',
                description: 'نحرص على تقديم خدمات عالية الجودة تفوق توقعات عملائنا',
              },
              {
                icon: 'ri-team-fill',
                title: 'الاحترافية',
                description: 'فريق عمل محترف ومدرب على أعلى مستوى لخدمتكم',
              },
              {
                icon: 'ri-customer-service-fill',
                title: 'رضا العملاء',
                description: 'نسعى دائماً لتحقيق رضا عملائنا وبناء علاقات طويلة الأمد',
              },
            ].map((value, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gray-50 rounded-3xl p-8 text-center hover:shadow-xl transition-all cursor-pointer group"
              >
                <div className="w-20 h-20 flex items-center justify-center bg-accent/10 group-hover:bg-accent rounded-2xl mx-auto mb-6 transition-all">
                  <i className={`${value.icon} text-5xl text-accent group-hover:text-primary transition-all`}></i>
                </div>
                <h3 className="text-2xl font-bold text-primary mb-4">{value.title}</h3>
                <p className="text-gray-600 leading-relaxed">{value.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Team & Expertise */}
      <section className="py-24 bg-primary">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-5xl md:text-6xl font-black text-white mb-6">فريق العمل والخبرة</h2>
              <p className="text-2xl text-gray-300 mb-12 leading-relaxed">
                نفخر بفريق عمل محترف يضم أكثر من 200 موظف من مهندسين ومشغلين وفنيين مدربين على أعلى مستوى
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
                {[
                  { number: '200+', label: 'موظف محترف', icon: 'ri-team-fill' },
                  { number: '50+', label: 'مهندس معتمد', icon: 'ri-user-star-fill' },
                  { number: '150+', label: 'مشغل مدرب', icon: 'ri-steering-fill' },
                ].map((stat, index) => (
                  <div
                    key={index}
                    className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 hover:bg-white/20 transition-all"
                  >
                    <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                      <i className={`${stat.icon} text-5xl text-accent`}></i>
                    </div>
                    <div className="text-5xl font-black text-white mb-2">{stat.number}</div>
                    <p className="text-gray-300 text-lg">{stat.label}</p>
                  </div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-24 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-5xl md:text-6xl font-black text-primary mb-4">لماذا نحن؟</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              نتميز بمجموعة من المزايا التي تجعلنا الخيار الأمثل لمشاريعك
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                icon: 'ri-truck-fill',
                title: 'أسطول ضخم ومتنوع',
                description: 'أكثر من 300 رافعة ومعدة بأحجام وقدرات مختلفة من 7 إلى 300 طن',
              },
              {
                icon: 'ri-time-fill',
                title: 'خبرة طويلة',
                description: 'أكثر من 15 عاماً من الخبرة في خدمة أضخم المشاريع في المملكة',
              },
              {
                icon: 'ri-shield-star-fill',
                title: 'معتمدون دولياً',
                description: 'جميع معداتنا معتمدة من TÜV الألمانية وتخضع لفحص دوري',
              },
              {
                icon: 'ri-customer-service-2-fill',
                title: 'دعم فني 24/7',
                description: 'فريق دعم فني متاح على مدار الساعة لضمان استمرارية عملك',
              },
              {
                icon: 'ri-price-tag-3-fill',
                title: 'أسعار تنافسية',
                description: 'نقدم أفضل الأسعار مع الحفاظ على أعلى معايير الجودة',
              },
              {
                icon: 'ri-hand-heart-fill',
                title: 'مرونة في التعامل',
                description: 'حلول مرنة ومخصصة تناسب احتياجات كل مشروع',
              },
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-gray-50 rounded-2xl p-8 hover:shadow-xl transition-all group cursor-pointer"
              >
                <div className="w-16 h-16 flex items-center justify-center bg-accent/10 group-hover:bg-accent rounded-xl mb-6 transition-all">
                  <i className={`${feature.icon} text-4xl text-accent group-hover:text-primary transition-all`}></i>
                </div>
                <h3 className="text-xl font-bold text-primary mb-3">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-primary to-primary-dark">
        <div className="container mx-auto px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
              هل أنت مستعد لبدء مشروعك؟
            </h2>
            <p className="text-2xl text-gray-300 mb-12 max-w-3xl mx-auto">
              تواصل معنا اليوم واحصل على استشارة مجانية وعرض سعر مخصص لمشروعك
            </p>
            <a
              href="tel:920000000"
              className="bg-accent hover:bg-accent-dark text-primary px-12 py-5 rounded-xl font-black text-xl transition-all shadow-2xl hover:shadow-accent/50 hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-3"
            >
              <i className="ri-phone-fill text-2xl"></i>
              <span>اتصل بنا الآن</span>
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;